let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fnkTE")).then(() => parcelRequire('h5RId'));